import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import {
	Stepper,
	Step,
	StepLabel,
	withStyles,
	StepButton,
	Tooltip,
	Hidden,
} from '@material-ui/core'
import { bindActionCreators } from 'redux'
import { stepperGoTo } from 'actions/view'
import { last } from 'lodash'

const StepperComponent = ({
	activeStep,
	steps,
	classes,
	taskID,
	stepperGoTo,
	selectedActionPrediction,
	lastCardSelected,
	sectionsLength,
}) => {
	// console.log(taskID)
	// console.log(lastCardSelected)
	// console.log(selectedActionPrediction)

	const stepper = (size) => {
		return (
			<Stepper
				classes={{ root: classes.root }}
				activeStep={activeStep}
				alternativeLabel
				nonLinear
				connector={size === 'small' ? null : undefined}
			>
				{steps.map((step, idx) => {
					const disabled =
						taskID === 'new' &&
						idx === 3 &&
						lastCardSelected !== 'blank' &&
						selectedActionPrediction === 'email' &&
						!sectionsLength

					const analyzeDisabled =
						taskID === 'new' &&
						((selectedActionPrediction === 'email' && idx === 4) ||
							(selectedActionPrediction !== 'email' && idx === 3))

					const stepComponent = (
						<Step key={`${step.label}${idx}LabelKey`}>
							<StepButton
								disabled={disabled || analyzeDisabled}
								icon={step.Icon}
								onClick={() => stepperGoTo(idx, 'task')}
							>
								<StepLabel
									classes={{
										alternativeLabel: classes.alternativeLabel,
										active: classes.active,
									}}
								>
									{step.label}
								</StepLabel>
							</StepButton>
						</Step>
					)

					return disabled ? (
						<Tooltip
							key={`${step.label}${idx}LabelKeyTooltip`}
							title="This step is disabled until an email type is chosen."
						>
							{stepComponent}
						</Tooltip>
					) : analyzeDisabled ? (
						<Tooltip
							key={`${step.label}${idx}LabelKeyTooltip`}
							title="This step is disabled until the task is created."
						>
							{stepComponent}
						</Tooltip>
					) : (
						stepComponent
					)
				})}
			</Stepper>
		)
	}

	return (
		<Fragment>
			<Hidden smDown>{stepper('medium')}</Hidden>
			<Hidden mdUp>{stepper('small')}</Hidden>
		</Fragment>
	)
}

const styles = (theme) => ({
	root: {
		padding: 0,
		[theme.breakpoints.up('md')]: {
			width: 500,
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: 10,
		},
		// marginTop: '-9px',
	},
	alternativeLabel: {
		marginTop: '0px !important',
		whiteSpace: 'nowrap',
		[theme.breakpoints.down('sm')]: {
			fontSize: 10,
		},
	},
	active: {
		color: '#18b940 !important',
	},
})

export default connect(
	(state) => ({
		activeStep: state.view.stepper.task,
		lastCardSelected: last(state.email.cardSelected),
		sectionsLength: Boolean(state.email.sections.length),
		// formID: state.signupForm.addOrEdit.formID,
	}),
	(dispatch) => bindActionCreators({ stepperGoTo }, dispatch),
)(withStyles(styles)(StepperComponent))
